module.exports = {"$schema":"http://json-schema.org/draft-04/schema#","title":"sourceAdjustment","type":"object","oneOf":[{"$ref":"sourceExactAdjustment"},{"$ref":"maxAdjustment"}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ripple-lib/dist/npm/common/schemas/objects/source-adjustment.json
// module id = exiO
// module chunks = 1